import {
  SET_HEADSET_ACCOUNT,
  SET_WEEDMAP_ACCOUNT,
  SET_WEBHOOKS,
  SET_HUBLIST,
  SET_EMPLOYEE_LIST,
  SET_TEAM_LIST,
  SET_SPRING_BIG_LIST,
  SET_TOOKAN_ACCOUNT_LIST,
  SET_TOOKAN_TEAM_LIST,
  SET_WEEDMAP_TAGS,
  SET_SPENCE_ACCOUNT_LIST,
  SET_ACH_ACCOUNT_LIST,
  SET_DCH_DISABLED_SHOP_LIST,
} from '../types/integration'

const initState = {
  headsetInfo: {},
  weedmapAccount: {},
  webHooksList: {},
  lastModified: new Date().getTime(),
  hubList: {},
  employeeList: {},
  teamList: [],
  springBigList: {},
  tookanList: {},
  tookanTeamList: {},
  weedmapTags: [],
  dispatchDisabledShopList: [],
}

export default (state = initState, action) => {
  switch (action.type) {
    case SET_HEADSET_ACCOUNT:
      return { ...state, headsetInfo: action.payload, lastModified: new Date().getTime() }
    case SET_WEEDMAP_ACCOUNT:
      return { ...state, weedmapAccount: action.payload, lastModified: new Date().getTime() }
    case SET_WEBHOOKS:
      return { ...state, webHooksList: action.payload, lastModified: new Date().getTime() }
    case SET_EMPLOYEE_LIST:
      return { ...state, employeeList: action.payload, lastModified: new Date().getTime() }
    case SET_TEAM_LIST:
      return { ...state, teamList: action.payload, lastModified: new Date().getTime() }
    case SET_HUBLIST:
      const { hubList } = state
      const updatedHubList = {
        ...hubList,
        [action.payload.apiKey]: action.payload.hubsList,
      }
      return { ...state, hubList: updatedHubList }
    case SET_SPRING_BIG_LIST:
      return { ...state, springBigList: action.payload }
    case SET_TOOKAN_ACCOUNT_LIST:
      return { ...state, tookanList: action.payload, lastModified: new Date().getTime() }
    case SET_TOOKAN_TEAM_LIST:
      return { ...state, tookanTeamList: action.payload, lastModified: new Date().getTime() }
    case SET_WEEDMAP_TAGS:
      return { ...state, weedmapTags: action.payload }
    case SET_SPENCE_ACCOUNT_LIST:
      return { ...state, spenceList: action.payload, lastModified: new Date().getTime() }
    case SET_ACH_ACCOUNT_LIST:
      return { ...state, achList: action.payload, lastModified: new Date().getTime() }
    case SET_DCH_DISABLED_SHOP_LIST:
      return {
        ...state,
        dispatchDisabledShopList: action.payload,
        lastModified: new Date().getTime(),
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/integration.js